"use client";

import {
	Children,
	PropsWithChildren,
	useEffect,
	useRef,
	cloneElement,
	isValidElement,
} from "react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import { SwiperOptions } from "swiper/types";

import { styled, Box } from "@mui/material";

export interface CarouselProps extends PropsWithChildren {
	onSlideChange?: (swiper: SwiperType) => void;
}
const Carousel: React.FC<CarouselProps> = ({ children, onSlideChange }) => {
	const swiperRef = useRef<SwiperType>();

	const pagination: SwiperOptions["pagination"] = {
		clickable: true,
		el: ".top-carousel__pagination",
	};

	useEffect(() => {
		const handleUpdateSwiper = () => {
			swiperRef.current?.update();
		};
		window.addEventListener("resize", handleUpdateSwiper);
		return () => {
			window.removeEventListener("resize", handleUpdateSwiper);
		};
	}, []);

	return (
		<Box component="div" className="relative top-carousel">
			<Swiper
				slidesPerView={1}
				pagination={pagination}
				modules={[Autoplay, Pagination, Navigation]}
				autoplay={{
					delay: 8000, // 3s per slide
					disableOnInteraction: false, // keep autoplay after manual swipe
				}}
				onInit={(swiper) => {
					swiperRef.current = swiper;
				}}
				onSwiper={(swiper) => {
					swiperRef.current = swiper;
				}}
				onSlideChange={onSlideChange}
				className="top-section-swiper"
			>
				{Children.map(children, (child, _index) => (
					<SwiperSlide key={_index} className="box-border h-auto">
						{isValidElement(child)
							? cloneElement(child, { slideIndex: _index })
							: child}
					</SwiperSlide>
				))}
			</Swiper>
			<CarouselPagination className="carousel-pagination">
				<div className="top-carousel__pagination pointer-events-auto"></div>
			</CarouselPagination>
		</Box>
	);
};
export default Carousel;

const CarouselPagination = styled(Box)`
	&.carousel-pagination {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		padding: 12px 0;
		pointer-events: none;

		.top-carousel__pagination {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			gap: 6px;

			.swiper-pagination-bullet {
				border-radius: 10px;
				transition: width 240ms linear;
				cursor: pointer;
				&.swiper-pagination-bullet-active {
					background: white;
					width: 22px !important;
				}
			}
		}
	}
`;
